import React, { useState } from 'react';

import { Upload, Button, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { getArrayBuffer } from '../../../shared/utils';

const uploadSignature = ({ rootContainer, setBytesToSave }) => {
  const [localFileList, setLocalFileList] = useState([]);

  const beforeUpload = (file, list) => {
    const isPng = file.type === 'image/png';
    if (!isPng) {
      notification.error({
        message: 'Warning',
        description: 'Only PNG file is allowed to upload.',
        top: 55,
        duration: 15,
        getContainer: rootContainer,
      });
    }

    const maxFileSize = 100; // KBs

    const isLess = file.size / 1024 < maxFileSize;
    if (!isLess) {
      notification.error({
        message: 'Warning',
        description: `File should not be bigger than ${maxFileSize} KBs.`,
        top: 55,
        duration: 15,
        getContainer: rootContainer,
      });
    }

    if (isPng && isLess) {
      setLocalFileList(list);
    } else {
      setLocalFileList([]);
      setBytesToSave(null);
    }

    return isPng && isLess;
  };

  const uploadFileStub = (options) => {
    options.onSuccess(
      {
        name: 'name',
        status: 'done',
        url: 'test',
        thumbUrl: 'test',
      },
      options.file,
    );
  };

  const handleChange = (info) => {
    if (info.file.status === 'done' && info.file.originFileObj) {
      getArrayBuffer(info.file.originFileObj, (imageArray) => {
        setBytesToSave(imageArray);
      });
    }
  };

  const handleRemove = (file) => {
    setBytesToSave(null);

    const newList = localFileList.filter((x) => x.uid != file.uid);
    setLocalFileList(newList);
  };

  return (
    <Upload
      name="stub"
      accept="image/png"
      listType="picture"
      maxCount={1}
      customRequest={uploadFileStub}
      beforeUpload={beforeUpload}
      onChange={handleChange}
      onRemove={handleRemove}
      fileList={localFileList}
    >
      <Button icon={<UploadOutlined />}>Upload</Button>
    </Upload>
  );
};

export default uploadSignature;
